/**
 * Attach a spinner to a button and disable it
 */
export function showSpinner(button, label = "Processing...") {
	if (!button) return;
	button.disabled = true;
	button.dataset.originalText = button.innerHTML;

	button.innerHTML = `
    <svg class="inline w-4 h-4 mr-2 text-white animate-spin" viewBox="0 0 24 24" fill="none">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z">
      </path>
    </svg>
    ${label}
  `;
}

/**
 * Restore original button content and enable it
 */
export function hideSpinner(button) {
	if (!button) return;
	button.innerHTML = button.dataset.originalText || "Submit";
	button.disabled = false;
}

/**
 * Show a fullscreen loader overlay
 */
export function showFullscreenLoader(message = "Loading...") {
	if (document.getElementById("fullscreen-loader")) return;

	const overlay = document.createElement("div");
	overlay.id = "fullscreen-loader";
	overlay.className = "fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50";

	overlay.innerHTML = `
    <div class="flex items-center space-x-3 text-white text-lg">
      <svg class="w-6 h-6 animate-spin" viewBox="0 0 24 24" fill="none">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="white" stroke-width="4"></circle>
        <path class="opacity-75" fill="white"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z">
        </path>
      </svg>
      <span>${message}</span>
    </div>
  `;

	document.body.appendChild(overlay);
}

/**
 * Hide fullscreen loader overlay
 */
export function hideFullscreenLoader() {
	const overlay = document.getElementById("fullscreen-loader");
	if (overlay) overlay.remove();
}
